<h3>Confirm {{ item  |translate }}</h3>
<p>Are you sure to {{ item | translate }}?</p>
<div>
  <button class="mat-raised-button" (click)="closeDialog()">Cancel</button>
  <button class="mat-raised-button mat-primary" (click)="confirmEvent.emit()">Confirm</button>
</div>
